var map = {
	"./channels.svg": 155,
	"./costStructure.svg": 156,
	"./customerRelationship.svg": 157,
	"./customerSegments.svg": 158,
	"./editTopNav.svg": 159,
	"./keyActivities.svg": 160,
	"./keyPartners.svg": 161,
	"./keyResources.svg": 162,
	"./revenueStreams.svg": 163,
	"./success.svg": 164,
	"./valueProposition.svg": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;